<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timeout = null;
    this.requestSeq = 0;
    this.destroyed = false;
    this.geocoderPromise = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.reset(false);
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.reset(true);
        return;
      }

      if (val !== this.select && !(this.select && val === this.select.text)) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage und verwirft verspätete Antworten
    reset(clearItems) {
      this.requestSeq++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;

      if (clearItems) {
        this.items = [];
      }
    },

    querySelections(value) {
      this.reset(false);

      const seq = this.requestSeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoderPromise.then(geocoder => {
          if (seq !== this.requestSeq || this.destroyed) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (seq !== this.requestSeq || this.destroyed || items === null) {
            return;
          }
          this.items = items.slice();
        }).catch(err => {
          if (seq === this.requestSeq && !this.destroyed) {
            console.log(err);
            this.items = [];
          }
        }).finally(() => {
          if (seq === this.requestSeq && !this.destroyed) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.reset(false);
      this.$emit("change", o);
    }
  }
};
</script>
